import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	franchiseList: []
};

const franchiseListSlice = createSlice({
	name: 'franchiseList',
	initialState,
	reducers: {
		franchiseListSet(state, action) {
			return {
				...state,
				franchiseList: action.payload
			};
		}
	}
});

export const { franchiseListSet } = franchiseListSlice.actions;

export default franchiseListSlice.reducer;
